import { useTranslation } from 'language/translator'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'redux/Stores/types'
import { TFetchStatus } from 'redux/reducers/Dashboards'

import {
  selectAiColumnIds,
  selectEntities,
  selectEntityData,
  selectOneEntity
} from 'redux/selectors/Entities'

export const useEntityFetchStatus = (): TFetchStatus => {
  return useSelector((state: ApplicationState) => state.EntityStore.fetchStatus)
}

export const useEntityData = () => {
  return useSelector(selectEntityData)
}

export const useEntities = () => {
  const { lang } = useTranslation()

  return useSelector((state: ApplicationState) => selectEntities(state, lang))
}

export const useEntity = (entityId: string) => {
  const { lang } = useTranslation()

  return useSelector((state: ApplicationState) =>
    selectOneEntity(state, entityId, lang)
  )
}

export const useAiColumnIds = (entityId: string | null): Set<string> => {
  return useSelector((state: ApplicationState) =>
    selectAiColumnIds(state, entityId)
  )
}
